/* eslint-disable */
import WaterActivities from "@/js/common/components/filterCriteria/waterActivities/WaterActivities";
import {propsDecorator} from "@/js/common/Domain/Service/mixins/decorators";
import template from "./template.html"

@propsDecorator({
    template
})
export default class WaterActivitiesDesktop extends WaterActivities{}